import { IconFile } from "@tabler/icons-react";
import { Stack, Text, ThemeIcon } from "@/components/ui";
import { esImagen, extensionDe } from "../utils/documento-helpers";
import { CodeViewer } from "./CodeViewer";

/**
 * Selecciona el viewer apropiado según el `contentType` del blob:
 *   · Imágenes  → `<img>` con el blob URL.
 *   · PDF       → `<iframe>` con el blob URL.
 *   · XML/JSON/texto → `<CodeViewer>` (con números de línea + highlight).
 *   · Otros     → CTA "Descargar para abrirlo".
 *
 * No revoca el blob URL · ese ciclo de vida lo maneja el padre (el row
 * que abrió la preview).
 */
export interface DocumentoPreview {
  blobUrl: string;
  contentType: string;
  blob: Blob;
}

export function DocumentoPreviewContent({ preview, nombre }: { preview: DocumentoPreview; nombre: string }) {
  const { blobUrl, contentType, blob } = preview;
  const ext = extensionDe(nombre);

  if (contentType.startsWith("image/") || esImagen(ext)) {
    return (
      <div className="flex h-full items-center justify-center p-4">
        <img src={blobUrl} alt={nombre} className="max-h-full max-w-full object-contain" />
      </div>
    );
  }

  if (contentType === "application/pdf" || ext === "pdf") {
    return <iframe src={blobUrl} title={nombre} className="size-full border-0" />;
  }

  if (contentType.startsWith("text/") || ext === "xml" || ext === "json" || ext === "csv" || ext === "txt") {
    return <CodeViewer blob={blob} ext={ext} contentType={contentType} />;
  }

  return <SinVistaPrevia />;
}

function SinVistaPrevia() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <Stack align="center" gap="xs">
        <ThemeIcon variant="filled" color="multiva" size="xl">
          <IconFile size={28} stroke={1.6} />
        </ThemeIcon>
        <Text fw={600} size="sm">
          Sin vista previa
        </Text>
        <Text size="xs" c="dimmed" ta="center" className="max-w-75">
          Este tipo de archivo no se puede previsualizar en el navegador. Descárgalo para abrirlo localmente.
        </Text>
      </Stack>
    </div>
  );
}
